import { Component, OnInit, ViewChild, ElementRef, Renderer2,Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Sugerencia } from '../../sugerencia/sugerencia.model';
import { NgForm, FormControl } from '@angular/forms';
import { CategoriaProducto } from '../../categoria-producto/categoria-producto.model';
import { Router , ActivatedRoute} from '@angular/router';
import { BackendService } from '../../../core/backend.service';
import { SnackService } from '../../../shared-services/snack.service';
import { FormValidatorService } from '../../../shared-services/form-validator.service';
import { Http } from '@angular/http';
import { MediaService } from '../../../shared-services/media.service';
import { NavigationService } from '../../../shared-services/navigation.service';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { HistoryProvider } from '../../../core/browser-providers';
import { ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { ActualizacionPrecioAdd } from '../actualizacion-precio-add.model';
import { Proveedor } from '../../proveedor/proveedor.model';
import { ProveedorSimple } from '../proovedor-simple.model';




@Component({
  selector: 'app-precio-modificacion-add',
  templateUrl: './precio-modificacion-add.component.html',
  styleUrls: ['./precio-modificacion-add.component.scss']
})
export class PrecioModificacionAddComponent implements OnInit {

  //sugerencias: Observable<Sugerencia[]>;
  //_selectedSugerencias: Sugerencia[] = [];
  separatorKeysCodes: number[] = [ENTER];
  
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;

  messageTitle: string;
  price: number = 0;
  validDates = [];
  maximoHasta: string;

  updatePrecios: ActualizacionPrecioAdd = new ActualizacionPrecioAdd();
  
  opcionesModificacion: string[];

  opcionesGrupoModificacion: string[];

  grupoModificacionElegido: string;

  opcionModElegida:string;

  proovedores: ProveedorSimple[] = [];

  sinLimiteTiempo: Boolean = true;

  esPromocion: Boolean = false;

  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  async ngOnInit() {
    this.snackService.spinner(true);
    this.opcionesModificacion= ["Aumento","Descuento"];
    this.opcionesGrupoModificacion=["General", "Proveedor"];

    //this.grupoModificacionElegido = "General";

    //this.getSugerencias();

    this.messageTitle = "Creacion de Modificacion de Precio"
    
    this.proovedores = await this.backendService.get(ProveedorSimple,"/new-productos/proveedores",null).toPromise();
    
    
    this.updatePrecios.aumentoPrecio = 0;
    this.updatePrecios.etiquetaModificacionPrecio = "";

    this.snackService.spinner(false);
    
  }  

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  
  back() {
    this.navigationService.back();
  }


  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    console.log(this.updatePrecios)
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea modificar los precios'/* + this.banner.description*/ +'?')
    .then( res => {
      if (res) {
       this.saveItem(res);
      }
    });
  }
  
  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);
      this.resetProveedor();
       // Update
       console.log(this.opcionModElegida);
       if(this.opcionModElegida == "Descuento"){
        this.updatePrecios.aumentoPrecio = this.updatePrecios.aumentoPrecio *-1
      }
        try {
          
           await this.backendService.create("/new-productos/update-all-precios", this.updatePrecios);
          this.snackService.success('Precio Agregado');
          this.router.navigate(['/modificaciones-precio']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
        
      }
    }
    
    async getRango() {
      let i = 0 ;
      while ( i < 90) {
        this.maximoHasta = '';
        const fechaSiguiente = new Date(this.updatePrecios.fechaDesde);
        fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
        if (this.validDates[fechaSiguiente.toISOString()]) {
          this.maximoHasta = fechaSiguiente.toISOString();
          return;
        } else {
          i++;
        }
      }
    }

    resetProveedor(){
      if(this.grupoModificacionElegido == "General"){
        this.updatePrecios.proveedorId = null;
      }
      

      console.log(this.updatePrecios.proveedorId);
    }

    sinLimiteFecha(){
      
      if(this.sinLimiteTiempo){
        this.updatePrecios.fechaHasta = "3000-06-09T03:00:00.000Z";
        this.sinLimiteTiempo = false;
      }else{
        this.updatePrecios.fechaHasta=null;
        this.sinLimiteTiempo = true;
      }
      
    }

    promocion(){
      
      if(this.updatePrecios.promocion){
        this.updatePrecios.promocion = false;
        
      }else{
        this.updatePrecios.promocion = true;
      }

      console.log(this.updatePrecios);
      
    }
    
}



// WEBPACK FOOTER //
// ./src/app/productos/modificacion-precio/precio-modificacion-add/precio-modificacion-add.component.ts